module.exports = __webpack_public_path__ + "static/media/slices3@2x.777016d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slices3@2x.png
// module id = 762
// module chunks = 0 1